import classNames from 'classnames';
import React from 'react';
import { childrenGetter } from 'src/components/Layouts/utils/childrenGetter';

import commonStyles from '../../../styles/common.module.scss';

const LeftSide: React.FC<React.AllHTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => {
  return <div className={classNames(commonStyles.leftColumn, className)} {...props} />;
};

const RightSide: React.FC<React.AllHTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => {
  return <div className={classNames(commonStyles.rightColumn, className)} {...props} />;
};

const Foot: React.FC = ({ children }) => {
  return <>{children}</>;
};

const Content: React.FC<React.AllHTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => {
  return <div className={classNames(commonStyles.mainColumn, className)} {...props} />;
};

export const Layout: React.FC<React.AllHTMLAttributes<HTMLDivElement>> & {
  RightSide: typeof RightSide;
  LeftSide: typeof LeftSide;
  Foot: typeof Foot;
  Content: typeof Content;
} = ({ className, children, ...props }) => {
  const [leftSide, rightSide, foot, content] = childrenGetter(children, [LeftSide, RightSide, Foot, Content]);

  return (
    <div className={classNames(commonStyles.container, className)} {...props}>
      <div className={commonStyles.content}>
        {leftSide}
        {content}
        {rightSide}
      </div>
      {foot}
    </div>
  );
};

Layout.RightSide = RightSide;
Layout.LeftSide = LeftSide;
Layout.Foot = Foot;
Layout.Content = Content;
